import React, { useRef, useEffect } from "react";
import videoFile from "../../components/car.mp4";
import audioFile from "../../components/air.m4a";

function AirBnb() {
  const videoRef = useRef(null);
  const audioRef = useRef(null);

  useEffect(() => {
    const playMedia = async () => {
      if (videoRef.current && audioRef.current) {
        try {
          await videoRef.current.play();
          await audioRef.current.play();
        } catch (error) {
          console.log("Autoplay blocked by browser, user interaction needed.");
        }
      }
    };
    playMedia();
  }, []);

  return (
    <div className="container">
      <div className="banner">
        <video
          ref={videoRef}
          src={videoFile}
          autoPlay
          loop
          muted
          playsInline
          className="video"
        />
      </div>

      <audio ref={audioRef} src={audioFile} />

      <div className="container_body">
        <div className="course">
          <h1>How to Start an AirBNB</h1>
          <p>
            Turn Properties into Profit with Airbnb! 🏡💵 Join Kerry Chappelle
            as he teaches the essentials of launching your first Airbnb. From
            selecting the right property to optimizing for guest satisfaction,
            learn how to create a successful Airbnb business that generates
            steady income. Let’s turn your space into a profitable venture! 🚀
            #AirbnbSuccess
          </p>
          <p>
            Kerry Washington IG:{" "}
            <a href="https://www.instagram.com/chappelleshow215/">
              https://www.instagram.com/chappelleshow215/
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AirBnb;
